import type { Entity, EntityInput } from '@teo/backend';

export function id(entity: Entity): string {
  switch (entity.type) {
    case 'ownership':
      return entity.ownershipId;
    case 'portfolio':
      return entity.portfolioId;
    case 'property':
      return entity.propertyId;
  }
}

// See note in the schema about how we should use branded types
export function entityIdToEntityInput(id: string): EntityInput {
  switch (id.substring(0, 4)) {
    case 'PROP':
      return { type: 'property', propertyId: id };
    case 'PORT':
      return { type: 'portfolio', portfolioId: id };
    case 'OWND':
      return { type: 'ownership', ownershipId: id };
    default:
      throw new Error('Unknown entity type');
  }
}
